/* eslint-disable @next/next/no-img-element */
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'

import { vehiclesNotifications as notifications } from '../../helper/notifications';
import { event } from '../../lib/gtag';

import styles from './styles.module.scss'
import Logo from '../../public/assets/icons/notification-logo.png'
import InfoIcon from '../../public/assets/icons/info-icon.svg'
import InfoIconBoi from '../../public/assets/nevo-boi/info.svg'
import CloseIcon from '../../public/assets/icons/close-white.svg'
import { useIsBoiWebsite } from "../Context/WebsiteType";

interface IVehicleNotification {
  openBaseOption: (trackEvent?: boolean) => void;
  close: () => void
}

const actionsArray = [
  'popupGoElectric',
  'popupTryThisEV',
  'popupBookTestDrive'
]

export default function VehicleNotification({ openBaseOption, close } : IVehicleNotification) {
  const [message, setMessage] = useState<any>()
  const [appear, setAppear] = useState(false)

  const audioPlayer = useRef<HTMLAudioElement>(null)
  const notificationRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (appear && message) {
      event(`${actionsArray[message.id]}Viewed`)
    }
  }, [appear, message])

  // play sound on load
  useEffect(() => {
    if (audioPlayer?.current) {
      setTimeout(() => {
        setAppear(true)
        
        setTimeout(() => {
          try {
            audioPlayer?.current?.play();
          } catch (e) {}
        }, 250)
      }, 8000)
    }
  }, [audioPlayer])

  // Set random message
  useEffect(() => {
    const randomMessage = notifications[Math.floor(Math.random() * notifications.length)]
    setMessage(randomMessage)
  }, [])
  
  const onClose = useCallback(() => {
    notificationRef?.current?.classList.add(styles.hideNotification)
    
    setTimeout(() => {
      close()
    }, 480)
  }, [notificationRef, close])

  const onClick = useCallback(() => {
    if (!message) return

    event(`${actionsArray[message.id]}Clicked`)
    openBaseOption(false)
  }, [openBaseOption, message])

  const appearStyle = useMemo(() =>{
    return { display: appear ? '' : 'none' }
  }, [appear]);

  const isBoiWebsite = useIsBoiWebsite()

  return <>
    <div className={isBoiWebsite ? styles.vehicleNotificationBoi : styles.vehicleNotification} ref={notificationRef} style={appearStyle}>
      <div className={isBoiWebsite ? styles.closeIconHolderBoi : styles.closeIconHolder}>
        <img className={isBoiWebsite ? styles.closeBoi : styles.close} src={CloseIcon.src} alt='Close icon' onClick={onClose}/>
      </div>

      <div className={isBoiWebsite ? styles.logoHolderBoi : styles.logoHolder}>
        <img className={isBoiWebsite ? styles.logoBoi : styles.logo} src={Logo.src} alt='Nevo logo' />
      </div>

      <div className={isBoiWebsite ? styles.messageBoi : styles.message}>
        <img src={isBoiWebsite ? InfoIconBoi.src : InfoIcon.src} className={isBoiWebsite ? styles.infoBoi : styles.info} alt='Point Icon' />
        <p className={isBoiWebsite ? styles.messageTextBoi : styles.messageText}>{ message?.text }</p>
      </div>

      <div className={isBoiWebsite ? styles.buttonHolderBoi : styles.buttonHolder}>
        <button className={`${isBoiWebsite ? styles.blueButtonBoi : styles.blueButton} ${isBoiWebsite ? 'dark-blue-button-boi' : 'blue-button'}`} onClick={onClick}>
          Book A Test Drive Today
        </button>
      </div>
    </div>

    <audio ref={audioPlayer} src='/assets/sounds/notification.mp3' />
  </>
}